import { useCurrentNavigationValues } from '../../../navigation';
import { useUser } from '../../../user-management';

type UnblockedAppletsValues = {
  classroomId: string | undefined;
  courseOrder: number;
  courseId: string;
  isStudentWithoutCourse: boolean;
  isTeacherWithoutCourseOrApplets: (appletsCode: string) => boolean;
};

export function useUnblockedAppletsValues(): UnblockedAppletsValues {
  const { currentCourse, currentClassroom } = useCurrentNavigationValues();
  const { user, isRole } = useUser();

  const navigationClassroomId = currentClassroom?.id;
  const navigationCourseOrder =
    currentClassroom?.courseOrder || currentCourse?.order || 0;
  const navigationCourseId =
    currentClassroom?.courseId || currentCourse?.id || '';

  const studentClassroomId = isRole.Student
    ? user?.studentData?.classroomId
    : undefined;
  const studentCourseOrder = isRole.Student
    ? user?.studentData?.courseOrder
    : undefined;
  const studentCourseId = isRole.Student
    ? user?.studentData?.courseId
    : undefined;

  const classroomId = navigationClassroomId || studentClassroomId;
  const courseOrder = navigationCourseOrder || studentCourseOrder || 0;
  const courseId = navigationCourseId || studentCourseId || '';

  const isStudentWithoutCourse = isRole.Student && !studentCourseId;
  const isTeacherWithoutCourseOrApplets = (appletsCode: string): boolean =>
    !isRole.Student && (!appletsCode || !courseId);

  return {
    classroomId,
    courseOrder,
    courseId,
    isStudentWithoutCourse,
    isTeacherWithoutCourseOrApplets,
  };
}
